/** Converte hex (#RGB ou #RRGGBB) para RGB ou null. */
export function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const normalized = hex.trim().replace(/^#/, '')
  if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(normalized)) return null

  const full =
    normalized.length === 3
      ? normalized
          .split('')
          .map((c) => c + c)
          .join('')
      : normalized

  const n = parseInt(full, 16)
  return {
    r: (n >> 16) & 255,
    g: (n >> 8) & 255,
    b: n & 255,
  }
}

/** Cor resultante do degradê (tint sobre base, percent 0–100). */
export function getShellTintBackground(
  tintColor: string,
  percent: number,
  baseColor: string = '#ffffff',
): string {
  const p = Math.min(100, Math.max(0, percent))
  if (p <= 0) return baseColor

  const tint = hexToRgb(tintColor)
  const base = hexToRgb(baseColor)
  if (!tint || !base) return baseColor

  const ratio = p / 100
  const r = Math.round(tint.r * ratio + base.r * (1 - ratio))
  const g = Math.round(tint.g * ratio + base.g * (1 - ratio))
  const b = Math.round(tint.b * ratio + base.b * (1 - ratio))
  return '#' + [r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')
}
